import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CardPreview from "./CardPreview";
import SavedCardPreview from "./SavedCardPreview";
import SetupForm from "./SetupForm";
import axios from "axios";

const CardContainer = ({ customerId, connectedStripeId }) => {
  const API_URL = "https://1d6q9mtu49.execute-api.us-west-2.amazonaws.com";
  const stripePublishableKey = "pk_test_cIzCaK7wSEWw901sNHD3Biqs008NVxgrAm";

  const [displayCardForm, setDisplayCardForm] = useState(false);
  const [cardDetails, setCardDetails] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);
  const [options, setOptions] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  //retrieve payment method for viewer if one is available and display card info
  // if no card is available show option to add a card
  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const { data } = await axios.post(`${API_URL}/retrieve-payment-methods`, {
        customerId,
        connectedStripeId,
      });

      // contains a list of payment methods objects with metadata about the payment method
      const paymentMethodArray = data.data;
      //if there is at least one payment method in the array display the first payment method
      if (paymentMethodArray.length) setCardDetails(data.data[0]);
      setIsLoading(false);
    })();
  }, []);

  // create a setUpIntent on stripe to get ready to add a new card to the customer Obj
  useEffect(() => {
    //if the card form is not open or the card form was closed,
    //return/reset the stripe promise back to null  
    if (!displayCardForm) return setStripePromise(null);

    // check if theres already an active stripe promise. if there is none, create one.
    if (!stripePromise){
      setStripePromise(
        loadStripe(stripePublishableKey, { stripeAccount: connectedStripeId })
      );
    }

    // create a new setupIntent object on the backend
    // and retrieve the clientSecret from the response
    (async () => {
      const { data } = await axios.post(`${API_URL}/create-setup-intent`, {
        customerId,
        connectedStripeId,
      });
      // set the options with an object containing the clientSecret
      setOptions({ clientSecret: data.clientSecret });
    })();
  }, [displayCardForm]);



  return (
    <>
      {!isLoading && cardDetails && (
        <SavedCardPreview
          connectedStripeId={connectedStripeId}
          setCardDetails={setCardDetails}
          paymentMethod={cardDetails}
        />
      )}

      {!isLoading && !displayCardForm && !cardDetails && (
        <CardPreview setDisplayCardForm={setDisplayCardForm} />
      )}

      {displayCardForm && options && !cardDetails && (
        <Elements stripe={stripePromise} options={options}>
          <SetupForm
            customerId={customerId}
            connectedStripeId={connectedStripeId}
            setCardDetails={setCardDetails}
            clientSecret={options.clientSecret}
            setDisplayCardForm={setDisplayCardForm}
          />
        </Elements>
      )}

      {isLoading && <div>Loading...</div>}
    </>
  );
};

export default CardContainer;
